import React from 'react';
import s from '../TierBadge.scss';
const Unlocked24 = ({ className  })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        opacity: "0.1",
        d: "M11 0.57735C11.6188 0.220084 12.3812 0.220085 13 0.57735L21.3923 5.42265C22.0111 5.77992 22.3923 6.44017 22.3923 7.1547V16.8453C22.3923 17.5598 22.0111 18.2201 21.3923 18.5774L13 23.4226C12.3812 23.7799 11.6188 23.7799 11 23.4226L2.6077 18.5774C1.98889 18.2201 1.6077 17.5598 1.6077 16.8453V7.1547C1.6077 6.44017 1.98889 5.77992 2.6077 5.42265L11 0.57735Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11 2.57735C11.6188 2.22008 12.3812 2.22008 13 2.57735L19.6603 6.42265C20.2791 6.77992 20.6603 7.44017 20.6603 8.1547V15.8453C20.6603 16.5598 20.2791 17.2201 19.6603 17.5774L13 21.4226C12.3812 21.7799 11.6188 21.7799 11 21.4226L4.33975 17.5774C3.72094 17.2201 3.33975 16.5598 3.33975 15.8453V8.1547C3.33975 7.44017 3.72094 6.77992 4.33975 6.42265L11 2.57735Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M17 9.5L15.8893 16.1644C15.8089 16.6466 15.3917 17 14.9029 17H9.09713C8.60829 17 8.1911 16.6466 8.11073 16.1644L7 9.5L10.125 11.375L12 7L13.875 11.375L17 9.5Z",
        className: s['bg-color']
    }));
Unlocked24.displayName = 'Unlocked24';
export default Unlocked24;
